enum AUTH_ACTION_TYPES {
  SET_USER_AUTH_DATA = 'SET_USER_AUTH_DATA',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  AUTH_USER = 'AUTH_USER',
  AUTH_DETAILS = 'AUTH_DETAILS',
  OTP_LOGIN = 'OTP_LOGIN',
  AUTH_CHECK_STATE = 'AUTH_CHECK_STATE',
  AUTH_START = 'AUTH_START',
  AUTH_SUCCESS = 'AUTH_SUCCESS',
  AUTH_FAIL = 'AUTH_FAIL',
  AUTH_CHECK_TIMEOUT = 'AUTH_CHECK_TIMEOUT',
  AUTH_INITIATE_LOGOUT = 'AUTH_INITIATE_LOGOUT',
  AUTH_LOGOUT = 'AUTH_LOGOUT',
  SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH',
  CLEAR_AUTH_ERROR = 'CLEAR_AUTH_ERROR',
  SSO_LOGIN = 'SSO_LOGIN',
  SEARCH_HOSPITALS = 'SEARCH_HOSPITALS',
  GET_HOSP_DETAIL = 'GET_HOSP_DETAIL',
  GET_HOSP_DETAIL_PAYER = 'GET_HOSP_DETAIL_PAYER',
  AUTH_PASSWORD_EXPIRED = 'AUTH_PASSWORD_EXPIRED',
  SET_ENCRYPTED_TOKEN = 'SET_ENCRYPTED_TOKEN',
  SET_FRESH_BOT_INIT = 'SET_FRESH_BOT_INIT',
  GET_SURVEY_OPTIONS = 'GET_SURVEY_OPTIONS',
  GET_SURVEY_OPTIONS_SUCCESS = 'GET_SURVEY_OPTIONS_SUCCESS',
  SAVE_SURVEY = 'SAVE_SURVEY',
  SAVE_SURVEY_SUCCESS = 'SAVE_SURVEY_SUCCESS',
  GET_USER_PERFORMANCE = 'GET_USER_PERFORMANCE',
  GET_USER_PERFORMANCE_SUCCESS = 'GET_USER_PERFORMANCE_SUCCESS',
  INCORRECT_EMAIL = 'INCORRECT_EMAIL',
  SKIPPED_EMAIL_VERIFICATION = 'SKIPPED_EMAIL_VERIFICATION',
  CORRECT_EMAIL = 'CORRECT_EMAIL',
  EMAIL_VERIFICATION_VERIFY_OTP = 'EMAIL_VERIFICATION_VERIFY_OTP',
  GET_HIP_HIU = 'GET_HIP_HIU',
  SET_OTP_FLOW_LOADER = 'SET_OTP_FLOW_LOADER',
  GOOGLE_AUTHENTICATE = 'GOOGLE_AUTHENTICATE',
  SET_DEEPLINK_DTO = 'SET_DEEPLINK_DTO',
  SET_OTP_TIMER_LIMIT = 'SET_OTP_TIMER_LIMIT',
  SET_IS_OTP_REQUEST_LIMIT_EXHAUSTED = 'SET_IS_OTP_REQUEST_LIMIT_EXHAUSTED',
}

export default AUTH_ACTION_TYPES;
